import { useState } from "react";
import MUITable from "../../../../../../common/components/mui-table/mui-table";
import "./user-dashboard-objective-list.scss";
import DeleteConfirmationPopup from "../../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import CompanyDashboardEditObjectivePopup from "../../../../../company-dashboard/company-dashboard-all-objective/company-dashbaord-edit-popup/company-dashboard-edit-object-popup";

const headers = [
  { key: "title", label: "Title" },
  { key: "assignedTo", label: "Assigned To" },
  { key: "timeline", label: "Timeline" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
];

const UserDashboardObjectiveList: any = (props: any) => {
  const {
    onRowClick,
    data,
    employeesList,
    statusListObjectives,
    handleEditObjective,
  } = props;
  const [isDeletePopupOpenObjective, setIsDeletePopupOpenObjective] =
    useState(false);
  const [deletePopupIdObjective, setDeletePopupIdObjective] =
    useState<any>(null);
  const [isOpenEditPopupObjective, setIsOpenEditPopupObjective] =
    useState(false);
  const [editObjectiveData, setEditObjectiveData] = useState<any>(null);

  const handleCloseEditPopupObjective = () => {
    setIsOpenEditPopupObjective(false);
  };
  const handleDeleteObjective = async (deletePopupIdObjective: any) => {
    if (!deletePopupIdObjective) return;
    try {
      setIsDeletePopupOpenObjective(false);
      setDeletePopupIdObjective(null);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="user-dashboard-objective-list-content">
        <MUITable
          columnNames={headers}
          rowsData={data}
          onRowClick={onRowClick}
          noRecordsTitle={"Please reload the page, or add new data."}
          noRecordsMessage={"Quiet zone! Nothing’s landed here for you yet."}
        />
      </div>
      <CompanyDashboardEditObjectivePopup
        isOpenAddPopup={isOpenEditPopupObjective}
        onCancel={handleCloseEditPopupObjective}
        newObjectiveData={editObjectiveData}
        setNewObjectiveData={setEditObjectiveData}
        employeesList={employeesList}
        statusListObjectives={statusListObjectives}
        onSave={handleEditObjective}
      />
      {isDeletePopupOpenObjective && (
        <DeleteConfirmationPopup
          isOpen={true}
          onClose={() => {
            setIsDeletePopupOpenObjective(false);
            setDeletePopupIdObjective(null);
          }}
          handleDelete={() => {
            handleDeleteObjective(deletePopupIdObjective);
            setIsDeletePopupOpenObjective(false);
          }}
          deleteId={deletePopupIdObjective}
        />
      )}
    </>
  );
};
export default UserDashboardObjectiveList;
